import type { SuggestedGasSettings } from '../model'
import type { TransKey } from '@root/shared/localization'

export const GAS_VARIANT_LABEL_MAP: Record<
  SuggestedGasSettings.SettingVariant | 'advanced',
  TransKey
> = {
  high: 'gas-settings.variant.high',
  market: 'gas-settings.variant.market',
  low: 'gas-settings.variant.low',
  advanced: 'gas-settings.variant.advanced',
}
